import React, { useEffect, useState } from "react";
import Modal from "react-modal";
// import { FaArrowLeft } from "react-icons/fa6";
// import { RxCross1 } from "react-icons/rx";
import { Button } from "react-bootstrap";
import moment from "moment";
import { format, addDays } from "date-fns";
import Tabs from "../../ui/Tabs";
import Incentives from "./Incentives";
import { useDispatch, useSelector } from "react-redux";
import { selectGymData } from "../../../redux/reducers/gymDataSlice";
import { fetchGymData } from "../../../data/APIs";
import DateRanger from "../../components-react/DateRanger";
import IncentivePenaltyForm from "../incentive-penalty/IncentivePenaltyForm";
import CreateIncentiveCategory from "../incentive-penalty/CreateIncentiveCategory";
import SelectDropdown from "../../components-react/SelectDropdown";
import RenewalTabs from "../renewals/RenewalTabs";
import { selectAuth } from "../../auth/auth.selector";

const RITabs = () => {
  const dispatch = useDispatch();
  const gymData = useSelector(selectGymData);
  const userInfo = useSelector(selectAuth);
  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const TABS = ["Renewals", "Incentives"];
  const [activeTab, setActiveTab] = useState(TABS[0]);
  const isAdmin = decryptedText?.account_type === "admin";
  const [selectedGyms, setSelectedGyms] = useState([]);
  const [addIncModal, setAddIncModal] = useState();
  const [addCatModal, setAddCatModal] = useState();
  const [startAndEndDate, setStartAndEndDate] = useState();

  function addIncModalToggle() {
    try {
      setAddIncModal(!addIncModal);
    } catch (error) {
      console.log(error);
    }
  }

  function addCateModalToggle() {
    try {
      setAddCatModal(!addCatModal);
    } catch (error) {
      console.log(error);
    }
  }

  // DATES
  const [dateRangerOpen, setDateRangerOpen] = useState(false);
  const initialRangeState = [
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: "selection",
    },
  ];
  const [rangeState, setRangeState] = useState(initialRangeState);
  const handleDateRangeChange = (item, name) => {
    setRangeState([item?.selection]);

    const formattedStartDate = format(item?.selection?.startDate, "yyyy-MM-dd");
    const formattedEndDate = format(item?.selection?.endDate, "yyyy-MM-dd");

    const formattedStart = moment(formattedStartDate)
      .tz("Asia/Kolkata")
      .format("DD-MM-YYYY");
    const formattedEnd = moment(formattedEndDate)
      .tz("Asia/Kolkata")
      .format("DD-MM-YYYY");

    setStartAndEndDate({
      ...startAndEndDate,
      startDate: formattedStartDate,
      endDate: formattedEndDate,
      selectedDates: `${formattedStart} - ${formattedEnd}`,
    });
  };
  // ------------- DATES --------------

  useEffect(() => {
    try {
      dispatch(fetchGymData(decryptedText?.token));
    } catch (error) {
      console.log(error);
    }
  }, []);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <div className="riTabsContainer">
      <Modal ariaHideApp={false} isOpen={addIncModal}>
        <div className="modal-body-k bg-white rounded-4">
          <div className="my-3">
            <button
              onClick={addIncModalToggle}
              className="btn-k px-3 x-small btn-muted-k"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-left"
                viewBox="0 0 16 16"
              >
                <path
                  fillRule="evenodd"
                  d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8"
                />
              </svg>
              {/* <FaArrowLeft />  */}
              Back
            </button>
          </div>
          <div className="w-full-k flex-k items-end-k js-between-k">
            <h2 className="fs-3">Incentive & Penalty</h2>
            <button
              onClick={addCateModalToggle}
              className="btn-k small btn-secondary-k"
            >
              + Incentive Category
            </button>
          </div>
          <IncentivePenaltyForm />
        </div>
      </Modal>

      <Modal isOpen={addCatModal} ariaHideApp={false}>
        <div className="createNewCTOModalContainer craeteCaregoryRenewal">
          <div className="w-full-k flex-k items-end-k js-between-k my-3">
            <h3>Create Category</h3>
            <button
              onClick={addCateModalToggle}
              className="btn-k p-3 rounded-full-k x-small btn-muted-k"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
                style={{ color: "#000000" }}
              >
                <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
              </svg>
              {/* <RxCross1 color="#000000" /> */}
            </button>
          </div>
          <CreateIncentiveCategory />
        </div>
      </Modal>

      <div className="tabsPayoutsContainer dualTab">
        {dateRangerOpen && (
          <div className="openedDateRanger">
            <DateRanger
              handleDateRangeChange={handleDateRangeChange}
              rangeState={rangeState}
              onClose={() => setDateRangerOpen(false)}
              onClear={() => {
                setDateRangerOpen(false);
                setRangeState(initialRangeState);
                setStartAndEndDate(null);
              }}
            />
          </div>
        )}

        <div className="renewal-header-gym flexBetween">
          <div className="">
            <span className="fs-med-k">Renewals & Incentives</span>
          </div>
          <div className="lastFlex">
            {isAdmin && (
              <div
                className="commonWrapper"
                style={{ height: "60px", minWidth: "400px" }}
              >
                <SelectDropdown
                  options={gymData}
                  selectedOption={selectedGyms}
                  setSelectedOption={(selectedValue) =>
                    setSelectedGyms(selectedValue)
                  }
                  name="Gym"
                />
              </div>
            )}

            <div className="columsDivsFlexEndFilterContainer gap-2">
              {dateRangerOpen ? (
                <div className="closeAndClearDateRangerButtons">
                  <Button
                    variant="primary"
                    onClick={() => setDateRangerOpen(false)}
                  >
                    Close
                  </Button>
                  <Button
                    variant="danger"
                    onClick={() => {
                      setDateRangerOpen(false);
                      setRangeState(initialRangeState);
                      setStartAndEndDate(null);
                    }}
                  >
                    Clear
                  </Button>
                </div>
              ) : startAndEndDate?.selectedDates ? (
                <button
                  onClick={() => {
                    setDateRangerOpen(true);
                  }}
                  className="btn-k btn-primary-k large"
                >
                  {startAndEndDate.selectedDates}
                </button>
              ) : (
                <button
                  onClick={() => {
                    setDateRangerOpen(true);
                  }}
                  className="btn-k btn-primary-k large"
                >
                  Select Date
                </button>
              )}

              {/* ----------- CREATE INCENTIVE/PENALTY BUTTON ------------- */}
            </div>
          </div>
        </div>

        <Tabs
          type={"secondary"}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          tabs={TABS}
          customClasss={"twoTabSystems"}
        />

        {activeTab === TABS[0] && (
          <RenewalTabs
            selectedGyms={selectedGyms}
            daysFilter={startAndEndDate}
          />
        )}

        {activeTab === TABS[1] && (
          <Incentives
            selectedGyms={selectedGyms}
            daysFilter={startAndEndDate}
          />
        )}
      </div>
    </div>
  );
};

export default RITabs;
